/**
 * Labels for the one toggle that reveals hidden surfacer cases: reviewed (every
 * finding has the caller's verdict), judged (with "Only unjudged" on, every
 * finding has someone's verdict in the version family) and skipped. Each label
 * names the one kind present, or says "hidden" for a mix, so the count is honest.
 */
export function hiddenToggleLabels(
  reviewed: number,
  judged: number,
  skipped: number,
): { showLabel: string; hideLabel: string; emptyLabel: string } {
  const kinds = (
    [
      ["reviewed", reviewed],
      ["judged", judged],
      ["skipped", skipped],
    ] as const
  ).filter(([, n]) => n > 0);
  if (kinds.length === 0) {
    return {
      showLabel: "Show reviewed (0)",
      hideLabel: "Hide reviewed",
      emptyLabel: "All cases reviewed",
    };
  }
  if (kinds.length === 1) {
    const [name, n] = kinds[0];
    return {
      showLabel: `Show ${name} (${n})`,
      hideLabel: `Hide ${name}`,
      emptyLabel: `All cases ${name}`,
    };
  }
  const names = kinds.map(([name]) => name);
  return {
    showLabel: `Show hidden (${reviewed + judged + skipped})`,
    hideLabel: "Hide",
    emptyLabel: `All cases ${names.slice(0, -1).join(", ")} or ${names.at(-1)}`,
  };
}
